import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import {
  Box,
  IconButton,
  List, ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import React from 'react';
import PropTypes from 'prop-types';
import {Clear} from '@mui/icons-material';

export default function PlayerAssignments({
  playerAssignments,
  selectedIndex,
  onSelected,
  onReloadData,
  onRevertItem,
}) {
  const handleAssignmentListItemClick = (event, index) => {
    onSelected(index);
  };

  return (
    <Paper
      sx={{
        minWidth: {xs: '35vw', md: '25vw'},
        maxWidth: {xs: '40vw', md: '30vw'},
        margin: 'auto',
        overflow: 'hidden',
      }}
    >
      <AppBar
        position="static"
        color="default"
        elevation={0}
        sx={{borderBottom: '1px solid rgba(0, 0, 0, 0.12)'}}
      >
        <Toolbar>
          <Box sx={{
            width: '100%',
            display: 'flex',
            flexWrap: 'nowrap',
            justifyContent: 'space-between',
          }}>
            <Typography variant="h5" marked="center">
              Assignments
            </Typography>
            <Tooltip title="Reload">
              <IconButton onClick={onReloadData}>
                <RefreshIcon color="inherit" sx={{display: 'block'}}/>
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>

      <List aria-label="secondary mailbox folder">
        {playerAssignments && playerAssignments.map((assignment, i) => {
          return (
            <ListItem
              disablePadding
              key={assignment.name}
              secondaryAction={assignment.changed ?
                (
                  <IconButton edge="end" aria-label="Clear" onClick={() => onRevertItem(i)}>
                    <Clear/>
                  </IconButton>
                ) : undefined
              }>
              <ListItemButton
                selected={i === selectedIndex}
                onClick={(event) => handleAssignmentListItemClick(event, i)}
              >
                <ListItemText
                  className={assignment.changed ? 'changed' : ''}
                  primary={
                    <React.Fragment>
                      <div className={'circle'}>
                        {assignment.name}
                      </div>
                      <span className={'vertical-align'}>
                        {assignment.displayName}
                      </span>
                    </React.Fragment>
                  }/>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
}
PlayerAssignments.propTypes = {
  playerAssignments: PropTypes.any.isRequired,
  selectedIndex: PropTypes.any,
  onSelected: PropTypes.func.isRequired,
  onReloadData: PropTypes.func.isRequired,
  onRevertItem: PropTypes.func.isRequired,
};
